<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row type="flex" justify="end">
        <el-input
            v-model="listQuery.user_id"
            placeholder="请输入用户 ID"
            style="width: 200px"
            class="filter-item"
            clearable
        />
        <el-input
            v-model="listQuery.name"
            placeholder="请输入户名"
            style="width: 200px"
            class="filter-item"
            clearable
        />
        <el-select
            v-model="listQuery.status"
            placeholder="状态"
            clearable
            style="width: 200px"
            class="filter-item"
        >
          <el-option
              :label="item.text"
              :value="item.value"
              v-for="(item, index) in status"
              :key="index"
          />
        </el-select>
        <el-button
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
        >搜索
        </el-button
        >
      </el-row>
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        element-loading-text="Loading"
        border
        fit
        highlight-current-row
    >
      <el-table-column align="center" label="ID" width="70">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="用户id" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="用户昵称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user ? scope.row.user.nickname : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="用户头像" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="!scope.row.user">-</span>
          <img v-else :src="scope.row.user.avatar" class="user-avatar"/>
        </template>
      </el-table-column>
      <el-table-column align="center" label="提现金额" min-width="120">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.money }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="申请时间" min-width="180">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="提现后余额" min-width="180">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.after_balance }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="处理状态" min-width="180">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'pending'" type="warning"
          >待处理
          </el-tag
          >
          <el-tag v-else-if="scope.row.status === 'wait_confirm'" type="warning"
          >用户待确认
          </el-tag
          >
          <el-tag v-else-if="scope.row.status === 'completed'" type="success"
          >已完成
          </el-tag
          >
          <el-tag v-else-if="scope.row.status === 'cancelled'" type="danger"
          >已取消
          </el-tag
          >

          <el-tag v-else type="danger">未申请</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          min-width="230"
          class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <!--          <el-button-->
          <!--              type="warning"-->
          <!--              size="mini"-->
          <!--              @click="ViewCertificate('view', scope.row)"-->
          <!--              v-if="scope.row.status === 'success'"-->
          <!--          >查看凭证</el-button-->
          <!--          >-->
          <!--          <el-button-->
          <!--              size="mini"-->
          <!--              type="primary"-->
          <!--              @click="ViewCertificate('upload', scope.row)"-->
          <!--              v-if="scope.row.status === 'pending'"-->
          <!--          >通过，上传凭证</el-button-->
          <!--          >-->
          <el-button
              size="mini"
              type="primary"
              @click="pass( scope.row.id)"
              v-if="scope.row.status === 'pending'"
          >通过
          </el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
          :current-page="listQuery.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.limit"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
    <DetailModal
        :show.sync="modalVisible"
        :detailData="selectedData"
        :detail="detail"
        @onUpdate="onDetailModalSubmit"
    ></DetailModal>
  </div>
</template>

<script>
import request from '@/utils/request'
import DetailModal from './components/DetailModal.vue'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
        modalVisible: false,
        selectedData: '',
      }
      return statusMap[status]
    },
  },
  components: {
    DetailModal,
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: '',
        name: '',
        bank_card_number: '',
        status: '',
      },
      modalVisible: false,
      selectedData: '',
      detail: {},
      status: [
        {
          value: "pending",
          text: '待处理',
        },
        {
          value: "wait_confirm",
          text: '用户待确认',
        },
        {
          value: "completed",
          text: '已完成',
        },
        {
          value: "cancelled",
          text: '已取消',
        },
      ],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/userCashOut/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        console.log(response)
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    ViewCertificate(type, row) {
      this.selectedData = type
      this.detail = row
      this.modalVisible = true
    },
    onDetailModalSubmit() {
      this.getList()
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    pass(val) {
      this.$confirm('此操作将通过该用户提现, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            request({
              url: '/api/backend/userCashOut/pass',
              method: 'POST',
              data: {id: val},
            }).then(() => {
              this.getList()
              this.$message({
                type: 'success',
                message: '操作成功!',
              })
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
